import React from 'react';

export const buildHeader = (title, componentName, description) => {
    return (
        <>
            <div className='d-flex justify-content-between'>
                <div style={{ fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>{title}</div>
                {componentName && (
                    <div
                        style={{
                            fontFamily: 'monospace',
                            marginRight: '10px',
                            marginTop: '13px',
                            height: 'max-content',
                            backgroundColor: 'whitesmoke',
                            border: '1px solid grey',
                            borderRadius: '2px',
                            padding: '0 4px',
                        }}>
                        {'<'}
                        {componentName}
                        {' ... />'}
                    </div>
                )}
            </div>
            {description && (
                <div
                    style={{
                        fontStyle: 'italic',
                        fontSize: 'smaller',
                        display: 'block',
                        padding: '.25rem 1rem 0 1rem',
                    }}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
            <div style={{ borderBottom: '1px solid grey', margin: '5px' }} />
        </>
    );
};

export const cardStyle = { width: '400px', margin: '20px', paddingBottom: '5px' };
export const headerCardStyle = { margin: '20px', width: 'calc(100% - 40px)', paddingBottom: '5px' };
